const trimTrailingSlash = (value) => value.replace(/\/+$|^$/g, '');
const trimLeadingSlash = (value) => value.replace(/^\/+/g, '');

const getPublicUrl = () => {
  if (typeof process === 'undefined') return '';
  const publicUrl = process.env.PUBLIC_URL || '';
  return publicUrl === '.' ? '' : trimTrailingSlash(publicUrl);
};

const getScriptBasePath = () => {
  if (typeof document === 'undefined') return '';
  const script = Array.from(document.scripts).find((scriptElement) => {
    return scriptElement.src && /\/static\/(js|css)\//.test(scriptElement.src);
  });
  if (!script?.src) return '';
  try {
    const url = new URL(script.src, window.location.href);
    return trimTrailingSlash(url.pathname.replace(/\/static\/(js|css)\/.*$/, ''));
  } catch {
    return '';
  }
};

export const APP_BASE_PATH = (() => {
  if (typeof window === 'undefined') return '';

  const publicUrl = getPublicUrl();
  if (publicUrl) return publicUrl;

  const meta = document.querySelector('meta[name="app-base-path"]')?.getAttribute('content');
  if (meta) return trimTrailingSlash(meta);

  return getScriptBasePath();
})();

export const getBackendUrl = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const backendBase = getApiBase().replace(/\/backend\/api$/, '/backend');

  if (normalizedPath.startsWith('/backend')) {
    return backendBase + normalizedPath.replace(/^\/backend/, '');
  }

  if (normalizedPath.startsWith('/uploads')) {
    return `${backendBase}${normalizedPath}`;
  }

  return `${window.location.origin}${APP_BASE_PATH}${normalizedPath}`.replace(/\/\/+/g, '/');
};

export const getApiBase = () => {
  const defaultBase = `${window.location.origin}${APP_BASE_PATH}/backend/api`;
  if (!APP_BASE_PATH && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    return '/backend/api';
  }
  return defaultBase;
};

export const resolveAsset = (path) => {
  const normalized = trimLeadingSlash(path);
  const base = APP_BASE_PATH || '';
  return `${base}/${normalized}`.replace(/\/{2,}/g, '/');
};
